import { render, staticRenderFns } from "./EditKBA.vue?vue&type=template&id=f7ed92d8&"
import script from "./EditKBA.vue?vue&type=script&lang=js&"
export * from "./EditKBA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports